import React, { useEffect } from 'react';

const DateComponent = ({ onUpdate }) => {
  useEffect(() => {
    const monthMap = {
      "01": "Jan",
      "02": "Feb",
      "03": "Mar",
      "04": "Apr",
      "05": "May",
      "06": "Jun",
      "07": "Jul",
      "08": "Aug",
      "09": "Sep",
      "10": "Oct",
      "11": "Nov",
      "12": "Dec"
    };
    const updateFormattedDateTime = () => {
      const currentDate = new Date();
      // const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day = String(currentDate.getDate()).padStart(2, '0');
      const date = `${day} ${monthMap[month]}`;

      const hours = String(currentDate.getHours()).padStart(2, '0');
      const minutes = String(currentDate.getMinutes()).padStart(2, '0');
      const seconds = String(currentDate.getSeconds()).padStart(2, '0');
      const time = `${hours}:${minutes}:${seconds}`;

      const formattedDateTimeString = `${date}  ${time}`;

      onUpdate(formattedDateTimeString); // Pass the formattedDateTimeString to the parent component
    };

    // Update the date and time initially and set up an interval to update every second
    updateFormattedDateTime();
    const intervalId = setInterval(updateFormattedDateTime, 1000);

    // Clear the interval when the component is unmounted
    return () => clearInterval(intervalId);
  }, [onUpdate]); // Ensure that useEffect only runs when onUpdate changes

  return (
    <>
      {/* json.stringify{formattedDateTime} */}
    </>
  );
};

export default DateComponent;
